module.exports = __webpack_public_path__ + "static/media/default_img_media.75c05cb8.jpg";